import type { CountDraft, Handoff, ToolCount, ToolInventory, ToolReport } from 'src/app/domain/tools'
import type { ToolStateModel } from '../state/tool.state'

/** Rows a write returned, merged into the inventory by id. */
export interface ToolPatch { readonly counts?: readonly ToolCount[]; readonly handoffs?: readonly Handoff[]; readonly reports?: readonly ToolReport[] }

export namespace ToolActions {
  export class Refresh {
    static readonly type = '[API-Tools] Refresh'
  }

  export class Init {
    static readonly type = '[Storage-Tools] Init'
    constructor(public payload: ToolStateModel) {}
  }

  export class Set {
    static readonly type = '[API-Tools] Set'
    constructor(public payload: ToolInventory) {}
  }

  export class Patch {
    static readonly type = '[API-Tools] Patch'
    constructor(public payload: ToolPatch) {}
  }

  export class SetDraft {
    static readonly type = '[UI-Tools] Set Draft'
    constructor(public payload: { readonly countId: number; readonly draft: CountDraft }) {}
  }

  export class ClearDraft {
    static readonly type = '[UI-Tools] Clear Draft'
    constructor(public payload: { readonly countId: number }) {}
  }
}
